import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {WindowRef} from '@spartacus/core';
import {LaunchDialogService} from '@spartacus/storefront';

import {AimoRoutingService} from '../../../cms-structure/routing/aimo-routing.service';
import {AimoCart, AimoOrderEntry} from '../../../model/cart.model';
import {AimoActiveCartService} from '../../../service/cart/aimo-active-cart.service';
import {AimoGTMProductAttributes} from '../../../service/gtm/aimo-gtm.model';
import {AimoProductModalService} from '../../../service/product/aimo-product-modal.service';
import {AimoCurrentProductService} from "../../../service/product/aimo-current-product.service";
import {Observable} from "rxjs";
import {AimoAssortmentService, LabelSuffix} from "../../../service/product/aimo-assortment.service";

@Component({
    selector: 'aimo-order-template-item',
    templateUrl: './aimo-order-template-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoOrderTemplateItemComponent implements OnInit {
    @Input() cart: AimoCart;
    @Input() entry: AimoOrderEntry;
    @Input() gtmProductAttributes?: AimoGTMProductAttributes;
    @Input() idSuffix: string;
    @Input() baseOrder = false;
    @Input() alreadyAddedToCart: number;
    @Input() printViewWithTable: boolean = false;
    addToCartForm: UntypedFormGroup;
    myAssortmentLabelSuffix$: Observable<LabelSuffix>;

    constructor(
        protected winRef: WindowRef,
        protected currentProductService: AimoCurrentProductService,
        protected activeCartService: AimoActiveCartService,
        protected launchDialogService: LaunchDialogService,
        protected aimoRoutingService: AimoRoutingService,
        protected productModalService: AimoProductModalService,
        protected assortmentService: AimoAssortmentService,
    ) {
    }

    ngOnInit(): void {
        this.addToCartForm = new UntypedFormGroup({
            quantity: new UntypedFormControl(this.entry.quantity, {updateOn: 'blur'}),
        });
        this.myAssortmentLabelSuffix$ = this.assortmentService.getMyAssortmentLabelSuffix();
    }

    openProductModal(sourceId: string): void {
        this.productModalService.openProductModal(
            this.entry.product.code,
            this.gtmProductAttributes,
            null,
            null,
            null,
            sourceId,
        );
    }

    changeQuantity(): void {
        const quantity = this.addToCartForm.get('quantity')?.value;
        this.entry.quantity = quantity;
        this.activeCartService.updateAimoEntry(
            {
                entryNumber: this.entry.entryNumber,
                product: {code: this.entry.product.code},
                quantity,
                gtmParams: {...this.entry.gtmParams}
            },
            this.cart.code,
            this.gtmProductAttributes,
        );
    }

    deleteEntry(entry: AimoOrderEntry): void {
        this.activeCartService.removeAimoEntry(entry, this.cart.code, this.gtmProductAttributes);
    }

    addToCart(entry: AimoOrderEntry): void {
        this.activeCartService.addAimoEntry(entry.product.code, entry.quantity, this.gtmProductAttributes);
    }

    isPikatukku(): boolean {
        return this.aimoRoutingService.isPikatukku();
    }

    isProductRemoved(): boolean {
        return !this.entry.productExists || this.entry.product.stock.salesBlockedFromNowUntilForever;
    }
}
